import { NavLink, Link } from "react-router-dom";

import styled, { css } from "styled-components";
import { Badge, Dropdown, Offcanvas } from "react-bootstrap";
import { SearchNormal1, Wallet2 } from "iconsax-react";

export const NavbarRight = styled.div``;

export const NavbarLogoImg = styled.img`
  @media screen and (max-width: 768px) {
    width: 88px;
    height: 25px;
  }
`;

const baseStyleOfNavLinks = css`
  color: var(--dark-color);
  position: relative;
  &::after {
    content: "";
    transition: all ease-out 0.3s;
    transition-property: right, left;
    height: 2px;
    background-color: var(--primary-color);
    border-radius: 5px;
    position: absolute;
    right: 50%;
    left: 50%;
    bottom: -10px;
  }
  &:hover::after,
  &.active-navbar-link::after {
    right: 0;
    left: 0;
  }
`;
export const StyledNavLink = styled(NavLink)`
  ${baseStyleOfNavLinks}
`;

export const NavAnchor = styled.a`
  ${baseStyleOfNavLinks}
`;

export const StyledSearchIcon = styled(SearchNormal1)`
  transform: rotate(90deg);
`;

export const NavbarLeft = styled.div``;

export const StyledNavbarButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bgPrimary }) =>
    $bgPrimary ? "var(--primary-color)" : "transparent"};
  color: ${({ $bgPrimary }) =>
    $bgPrimary ? "var(--white-color)" : "var(--primary-color)"};
  border: 1px solid var(--primary-color);
  border-radius: 12px;
  height: 44px;
  min-width: 120px;
  transition: all ease 0.3s;
  cursor: pointer;
  &:hover {
    color: ${({ $bgPrimary }) =>
      $bgPrimary ? "var(--white-color)" : "var(--primary-color)"};
  }
  @media screen and (max-width: 768px) {
    border-radius: 6px;
    height: 36px;
    min-width: 110px;
    font-size: 14px;
  }
`;

// User is login
export const StyledBadge = styled(Badge)`
  top: -10px;
  right: -10px;
`;

export const StyledDropdown = styled(Dropdown)`
  height: 44px;
  background-color: transparent !important;
  transition: all ease 0.3s;
  &:hover {
    background-color: var(--primary-color);
    color: var(--white-color);
  }
`;

export const StyledDropdownToggle = styled(Dropdown.Toggle)`
  border: 0.5px solid var(--primary-color);
  border-radius: 12px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  min-width: 10rem;
  color: var(--blue-color-dark);
  font-size: var(--font-size-sm);
  &:hover {
    background-color: var(--primary-color);
    color: var(--white-color);
    svg {
      color: var(--white-color);
    }
  }
  svg {
    color: var(--primary-color);
  }
`;

const baseStyleOfDropdownItems = css`
  background: transparent;
  display: flex;
  cursor: pointer;
  &:hover {
    color: var(--primary-color);
    background: initial;
    svg {
      color: inherit;
    }
  }
`;
export const StyledDropdownMenu = styled(Dropdown.Menu)`
  text-align: center;
  font-size: var(--font-size-sm);
  border: 0.5px solid var(--primary-color);
  border-radius: 12px;
  & .dropdown-item {
    ${baseStyleOfDropdownItems}
    color: var(--text-color-dark);
    column-gap: 1rem;
  }
`;

export const StyledWalletIcon = styled(Wallet2)`
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
`;

// Responsive menu
export const StyledOffcanvas = styled(Offcanvas)`
  max-width: 300px;
  box-shadow: var(--box-shadow2);
  border-radius: 12px 0 0 12px;
  hr {
    height: 0.5px;
  }
`;
export const SidebarTop = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;
export const WalletBalanceBox = styled.div`
  color: var(--white-color);
  background-color: var(--primary-color);
  padding: 1rem;
  text-align: center;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const SideBarSegment = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  & .dropdown-item {
    ${baseStyleOfDropdownItems}
    color: var(--dark-color);
    column-gap: 9px;
    svg {
      color: var(--deactive-color);
    }
  }
`;
